import { useState } from "react";

// Optimistic local update for a contract's disposition, then a server
// round-trip. Mirrors useStatusUpdate's optimistic-then-persist pattern.
export function useDispositionUpdate({ api, setContracts, onError }) {
  const [savingDispositions, setSavingDispositions] = useState(() => new Set());

  const updateDisposition = async (contractNumber, disposition) => {
    setContracts((prev) =>
      prev.map((c) =>
        c.number === contractNumber ? { ...c, disposition } : c,
      ),
    );
    setSavingDispositions((prev) => new Set(prev).add(contractNumber));
    try {
      await api.put(`/api/commission/contracts/${contractNumber}/disposition`, {
        disposition,
      });
    } catch {
      onError?.();
    } finally {
      setSavingDispositions((prev) => {
        const next = new Set(prev);
        next.delete(contractNumber);
        return next;
      });
    }
  };

  return { updateDisposition, savingDispositions };
}
